/* CloneAction.js */

"use strict";
const Registrations = require("../../../../../RegistrationNamespaces");
const CreateComponent = require("../create/CreateOsCatalogComponent");
const _ = require("lodash");

class CloneAction {
    constructor(
        logger,
        gameEditor,
        modalUserFeedback,
        OsImageCatalogEntity,
        userSession,
        activeView
    ) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._osCatalogEntity = new OsImageCatalogEntity(userSession.activeOrganization.id);
        this._OsCatalog = OsImageCatalogEntity;
        this._modalUserFeedback = modalUserFeedback;
        this._userSession = userSession;
        this._activeView = activeView;
        this._images = undefined;
        this._firstRun = true;

        this.run = this.run.bind(this);
        this.cloneErrorHandler = this.cloneErrorHandler.bind(this);
    }
    run() {
        if (this._activeView) {
            this._selectedCatalogId = this._activeView.selectedRows[0];
            this._selectedCatalog = this._activeView._pagingCatalogFeed.getOsCatalogEntityById(
                this._selectedCatalogId
            );

            return this._OsCatalog
                .retrieveOsImageCatalog(
                    this._userSession.activeOrganization.id,
                    this._selectedCatalogId
                )
                .then((osCatalog) => {
                    this._osCatalogEntity.name = this._selectedCatalog.name.trim() + "-1";
                    this._osCatalogEntity.description = this._selectedCatalog.description;
                    this._osCatalogEntity.rules = this._selectedCatalog.rules;
                    // Updating Skus
                    this._osCatalogEntity.skus = osCatalog.skus;

                    // getting current Catalog images
                    return osCatalog
                        .loadRelatedOsImages({})
                        .then((feed) => {
                            this._images = feed;

                            return this.cloneCatalog();
                        })
                        .catch((err) => {
                            this.cloneErrorHandler(err);
                        });
                });
        }
    }
    cloneErrorHandler(err) {
        if (err.userRejected) {
            return;
        }
        const errorCode = err && err.errorCode;

        switch (errorCode) {
            case "EntityAlreadyExists":
                if (this._firstRun) {
                    this._firstRun = false;
                    return this.requestCatalogName(false);
                }
                return this.requestCatalogName(true);
            case "ExceededDeviceCount":
            /* falls through */
            default:
                return this.showError(err);
        }
    }

    cloneCatalog() {
        let newItemId;
        if (this._images && this._images.length) {
            this._images.map((image) => {
                this._osCatalogEntity.addToOsImagesRelationship(image.id);
            });
        }
        return this._osCatalogEntity
            .create()
            .then((result) => {
                newItemId = result.id;
                return this._modalUserFeedback.hideDisplayed().then(() => {
                    return this.launchCatalogEditor(result.id, result.properties.name);
                });
            })
            .then(() => {
                if (typeof this._activeView.resetSelection === "function") {
                    // making a small delay, to be sure the grid is updated with new item
                    _.delay(() => this._activeView.resetSelection([newItemId]), 200);
                }
                return Promise.resolve(this);
            });
    }

    requestCatalogName(isNotUniq) {
        return this._modalUserFeedback
            .displayCustom(
                new CreateComponent(
                    this._logger,
                    "Clone Catalog",
                    isNotUniq
                        ? "The entered name is not unique. Please specify a unique name for this cloned catalog."
                        : "Please specify a unique name for this cloned catalog."
                ),
                {dontHide: true}
            )
            .then((result) => {
                return this._modalUserFeedback.displayLoading().then(() => {
                    this._osCatalogEntity.name = result.trim();
                    // adding images to the cloned catalog
                    return this.cloneCatalog();
                });
            })
            .catch((err) => {
                if (err && err.userRejected) {
                    this._logger.warn({error: err}, "CaptureAction.run() - User Canceled");
                    return this._modalUserFeedback.hideDisplayed();
                } else {
                    return this.cloneErrorHandler(err);
                }
            });
    }
    launchCatalogEditor(id, name) {
        if (!id) {
            throw "Catalog creation error, invalid catalog id.";
        }
        let editorState = {
            fqn: Registrations.OS_CATALOG_EDITOR_VIEW_DETAILS,
            viewState: {createMode: true},
        };
        let launchOpts = {id: id, title: name};
        return this._gameEditor.launchOsCatalogEditor(editorState, launchOpts);
    }

    showError(error) {
        return this._modalUserFeedback.displayError({error}).catch((error) => {
            if (error.userRejected) {
                return;
            }
            this._logger.warn({error}, "Clone action error.");
        });
    }
}

module.exports = CloneAction;

CloneAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.OsImageCatalog",
    "$teve.userSession",
    "gameEditor.activeView",
];

CloneAction.$displayDetails = {
    type: "Action",
    name: "CloneAction",
    icon: "common.duplicate",
    title: "Clone Entry",
    shown: true,
    order: 3,
};
